var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-aside',{attrs:{"width":"250px"}},[_c('Group',{attrs:{"group-type":"D1402"}})],1),_c('el-container',[_c('el-main',[_vm._v("Main")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }